import { render, staticRenderFns } from "./OrderSettingsForm.vue?vue&type=template&id=91329786"
import script from "./OrderSettingsForm.vue?vue&type=script&lang=js"
export * from "./OrderSettingsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports